import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function Content(props) {
  return (
    <Box sx={{ width: '100%', maxWidth: 500 }}>
      <Typography variant="h1" gutterBottom>
        {props.details.title}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {props.details.body}
      </Typography>
      <Typography variant="caption" display="block" gutterBottom>
        {props.details.description}
      </Typography>
    </Box>
  );
}
